"use client";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ReadyCTA({
  leftImage = "/images/synergy.png",
  rightImage = "/images/rocket.png",
  title = "Ready to get started?",
  description = "Buy your first Synergy Coin today, unlock your referral link, and join a thriving community of earners.Start your journey toward rewards, growth, and connection, all in one platform.",
  buttonLabel = "Get Started Now",
  onButtonClick,
}) {
  const navigate = useNavigate();
  const handleClick = () => {
    if (onButtonClick) {
      onButtonClick();
      return;
    }
// data
    navigate("/signup");
  };

  return (
    <section className="relative flex justify-center bg-black px-4 py-14 sm:px-6 sm:py-20">
      <div className="relative isolate w-full max-w-[28rem] overflow-visible rounded-[28px] bg-gradient-to-r from-[#240F35] to-[#07174D] px-5 py-10 text-center shadow-[0_40px_140px_rgba(66,45,255,0.35)] sm:max-w-3xl sm:rounded-[32px] sm:px-12 sm:py-14 md:max-w-5xl md:rounded-[36px] md:py-16">
        {/* Background concentric arcs */}
        <svg
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 -z-10 h-full w-full"
          viewBox="0 0 1440 560"
          preserveAspectRatio="none"
        >
          {/* sdjsdj */}
          <defs>
            <linearGradient id="ctaArcGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(255,255,255,0.05)" />
              <stop offset="100%" stopColor="rgba(255,255,255,0.15)" />
            </linearGradient>
          </defs>
          <circle
            cx="720"
            cy="560"
            r="320"
            fill="none"
            stroke="url(#ctaArcGradient)"
            strokeWidth="1.5"
          />
          <circle
            cx="720"
            cy="560"
            r="420"
            fill="none"
            stroke="url(#ctaArcGradient)"
            strokeWidth="1.2"
          />
          <circle
            cx="720"
            cy="560"
            r="520"
            fill="none"
            stroke="url(#ctaArcGradient)"
            strokeWidth="1"
          />
        </svg>

        {/* LEFT IMAGE (half in / half out) - Hidden on mobile */}
        <div className="absolute -left-16 top-1/2 hidden h-32 w-32 -translate-y-[125%] md:block sm:h-40 sm:w-40">
          <div className="relative h-full w-full">
            <div className="pointer-events-none absolute inset-[-18%] rounded-full bg-[radial-gradient(circle_at_35%_30%,rgba(140,60,221,0.4),rgba(156,117,255,0.25)_60%,rgba(51,22,118,0.35))] blur-xl animate-coin-glow" />
            <img
              src={leftImage}
              alt="Decor coin"
              className="relative h-full w-full object-contain animate-coin-sway"
            />
          </div>
        </div>

        {/* RIGHT IMAGE (half in / half out) - Hidden on mobile */}
        {/* <div className="absolute -right-24 bottom-[-60px] hidden h-40 w-40 md:block sm:h-48 sm:w-48">
          <div className="relative h-full w-full">
            <div className="pointer-events-none absolute inset-x-[32%] bottom-[-28%] h-16 rounded-full bg-[#9c55ff]/25 blur-2xl animate-rocket-thrust sm:bottom-[-32%] sm:h-20" />
            <img
              src={rightImage}
              alt="Decor rocket"
              className="h-full w-full object-contain drop-shadow-[0_25px_55px_rgba(7,3,29,0.55)] animate-rocket-flight"
            />
          </div>
        </div> */}

        {/* Heading */}
        <h2 className="text-2xl font-semibold text-white sm:text-3xl md:text-5xl">{title}</h2>

        {/* Description */}
        <p className="mt-4 text-sm text-white/70 sm:text-base md:mx-auto md:max-w-2xl">
          {description}
        </p>

        {/* Button */}
        <button
          type="button"
          onClick={handleClick}
          className="mt-8 inline-flex w-full max-w-[220px] items-center justify-center rounded-lg bg-[#8C3CDD] px-8 py-3 text-sm font-semibold text-white shadow-[0_18px_35px_rgba(152,71,255,0.35)] transition-transform duration-200 hover:translate-y-[-2px] hover:bg-[#923df7] sm:max-w-none sm:w-auto"
        >
          {buttonLabel}
          <span className="ml-2 text-lg">→</span>
        </button>
      </div>
    </section>
  );
}
